import React from "react";
import {useField, useFormikContext} from "formik";
import DatePicker from "react-datepicker";
import sk from 'date-fns/locale/sk';
import dayjs from "dayjs";

export const QuarterPickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field, {setValue}] = useField(props);
  return (
    <DatePicker
      {...field}
      {...props}
      locale={sk}
      showQuarterYearPicker
      timeFormat="HH:mm"
      dateFormat="yyyy, QQQ"
      placeholderText={props.placeholder}
      selected={!field.value ? null : new Date(field.value)}
      value={!field.value ? null : new Date(field.value)}
      onChange={val => {
          let newVal = val ? dayjs(val).toISOString() : null
          setFieldValue(field.name, newVal);
      }}
    />
  );
};
